export default {
    origin: '',
    currentUrl: '',
    deviceType: '',
    recipeSchemaItems: []
}
